import { Render, Data } from '@measured/puck';

import { useConfig } from '../config/use-config';
import { PuckReportMetadata } from '../report-types';
import { SurveySetWithoutModel } from '../survey-types';

type IPuckRenderProps = {
  readonly surveys: SurveySetWithoutModel;
  readonly reportDefinition: Data;
} & PuckReportMetadata;

function PuckRender({
  surveys,
  reportDefinition,
  answers = {},
  attachments = [],
  healthcareSystemLookupId,
  healthcareSystemPatientId,
  hasLookedUpHealthcareSystemId,
  isPdf,
  piSystemId,
  webReportUrl,
  respondents,
  reportStatus,
  reportTimestamp,
}: IPuckRenderProps) {
  const config = useConfig({
    answers,
    isPdf,
    reportStatus,
    reportTimestamp,
    surveySet: surveys,
  });

  if (!config) return <div>Config loading</div>;

  const metadata: PuckReportMetadata = {
    answers,
    attachments,
    hasLookedUpHealthcareSystemId,
    healthcareSystemLookupId,
    healthcareSystemPatientId,
    isPdf,
    piSystemId,
    reportStatus,
    reportTimestamp,
    respondents,
    webReportUrl,
  };

  return <Render config={config} data={reportDefinition} metadata={metadata} />;
}

export { type IPuckRenderProps, PuckRender };
